// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2P2Gv","messages":"Chat_messages__37utx","dateDivider":"Chat_dateDivider__WTZRH"};